import { render, staticRenderFns } from "./ClampedComment.vue?vue&type=template&id=7a589d30&lang=pug&"
import script from "./ClampedComment.vue?vue&type=script&lang=js&"
export * from "./ClampedComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports